import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Button, Icon, Select } from 'antd';

import { getRoleList } from 'Root/http';
import { isSupervisorUser } from 'Auth/redux/auth.redux';

import s from './style/RoleSelector.pcss';
import Loader from '../../../shared/components/Loader/Loader';


const Option = Select.Option;

@connect(
  state => ({
    isSupervisor: isSupervisorUser(state),
  }),
)
export default class RoleSelector extends React.Component {
  static propTypes = {
    isSupervisor: PropTypes.bool.isRequired,
    visible: PropTypes.bool.isRequired,
    onVisible: PropTypes.func.isRequired,
    onAddRole: PropTypes.func.isRequired,
    existRoles: PropTypes.arrayOf(PropTypes.string),
  };

  static defaultProps = {
    existRoles: [],
  };

  state = {
    roles: [],
    saving: false,
    selectedRole: null,
  };

  componentDidMount() {
    getRoleList().then((roles) => {
      const nonLockedRoles = roles.filter(r =>
        !(this.props.isSupervisor && r.forbiddenForSupervisorAdmin));
      this.setState({ roles: nonLockedRoles });
    });
    document.addEventListener('mousedown', this.onHandleBlur);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.onHandleBlur);
  }

  setRef = (ref) => {
    this.mainContainer = ref;
  };

  onHandleBlur = (e) => {
    if (this.mainContainer && !this.mainContainer.contains(e.target)) {
      this.props.onVisible(false);
    }
  };

  onAddRole = () => {
    this.setState({ saving: true }, () => {
      this.props.onAddRole(this.state.selectedRole).then(() => {
        this.setState({ selectedRole: null, saving: false });
        this.props.onVisible(false);
      });
    });
  };

  changeSelectedRole = selectedRole => this.setState({ selectedRole });

  renderOverlay = () => {
    const { roles, saving } = this.state;
    const { isSupervisor } = this.props;
    const withoutLocked = roles.filter(role => !isSupervisor || !role.forbiddenForSupervisorAdmin);
    const filteredRoles = withoutLocked.filter(role => !this.props.existRoles.includes(role.id));
    return (
      <div className={s.overlayContainer}>
        <div className={s.addHeader}>
          <div className={s.addHeaderLabel}>Добавить роль</div>
          <Button
            type="primary"
            className={s.createBtn}
            disabled={!this.state.selectedRole || saving}
            onClick={this.onAddRole}
          >
            Добавить
          </Button>
        </div>
        {saving && <Loader fullScreen={false} />}
        {!saving &&
          <div className={s.inputContainer}>
            <div className={s.inputLabel}>Роль</div>
            <Select
              placeholder="Выбрать..."
              getPopupContainer={triggerNode => triggerNode}
              value={this.state.selectedRole}
              onChange={this.changeSelectedRole}
            >
              {filteredRoles.map(role => <Option key={role.id}>{role.name}</Option>)}
            </Select>
          </div>
        }
      </div>
    );
  }

  render() {
    const { visible } = this.props;
    return (
      <div ref={this.setRef} className={s.selectorContainer}>
        <div className={s.addContainer} onClick={() => this.props.onVisible(true)}>
          <Icon type="plus" theme="outlined" />
          <div className={s.addBtn}>Добавить роль</div>
        </div>
        {visible && this.renderOverlay()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/shared/RoleSelector.js